import {Base} from "./Base";

export enum PartnerType {
    Individual = 'INDIVIDUAL',
    Company = 'COMPANY',
}

export enum PartnerStatus {
    Active = 'ACTIVE',
    Blocked = 'BLOCKED',
}

export interface Partner extends Base {
    id: string // PK

    type: PartnerType
    code?: string // sifra
    name: string
    responsiblePersonFirstName?: string
    responsiblePersonLastName?: string
    nationalIdNumber?: string // Broj licne karte
    nationalIdIssueLocation?: string // SUP
    personalCodeNumber?: string // JMBG
    address?: string
    city?: any
    fax?: string
    phone?: string
    mobile?: string
    email?: string
    isVat?: boolean
    vatNumber?: string
    companyNumber?: string
    region?: string
    commercialist1?: string
    commercialist2?: string
    bankName?: string
    bankIdNumber?: string // prve tri cifre broja racuna (JIB)
    bankAccountNumber?: string
    status: PartnerStatus
}
